module.exports = __webpack_public_path__ + "img/mobile.99a72ed6.svg";